module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(!_vm.error) ? [_c('campaign-step')] : [([404, 403].includes(_vm.error.code)) ? _c('not-found') : _c('h1', [_vm._v(_vm._s(_vm.error))])]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03dcb432"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/campaign/Campaign.vue
// module id = 1997
// module chunks = 1